import gsap from 'gsap'
import {removeFromCart} from './CartFunctions'
import {isAllMobileDevices, InputCoupon, minicart, homeUrl} from './bundle'

class Checkout {
    constructor() {
        this.couponWrapper = document.querySelector('.coupon')
        this.inputCoupon = new InputCoupon(this.couponWrapper.querySelector('.input'))
        this.submitCouponBtn = document.querySelector('.submit-coupon')
        this.iconaBagQty = document.querySelector('.js-bag-counter')

        this.ship_different = document.getElementById('ship-to-different-address')
        // this.create_account = document.querySelector('.woocommerce-account-fields .form-row.create-account')
        this.errorPanel = document.querySelector('.checkout--error-panel')
        this.errorPanelError = document.querySelector('.checkout--error-panel .js-error')
        this.errorPanelErrorProgressBar = document.querySelector('.checkout--error-panel .bar')
        this.billing_country = document.getElementById('billing_country')
        this.pay = document.getElementById('payment')
        this.payment_methods = this.pay.querySelectorAll('.wc_payment_methods li')

        this.timeout = 0
        this.errorPanelProgress = {value: 0}
        this.isUploading = false

        this.initEvents()

    }

    initEvents() {
        this.checkoutPrivacy()
        if(!isAllMobileDevices){
            // this.fixedErrorPanel()
        }
        this.errorPanel.addEventListener('click', () => {

            this.closeErrorPanel()
        })

        this.submitCouponBtn.addEventListener('click', () => {
            if (this.isUploading) return
            this.isUploading = true
            this.inputCoupon.checkIfIsEmpty()
            if (this.inputCoupon.isEmpty) {
                this.inputCoupon.showMessage(this.inputCoupon.isEmpty)
                this.isUploading = false
            }
            else {
                this.applyCoupon()
            }
        })
        
        if(this.ship_different !== null){
            this.ship_different.addEventListener('click', () => {
                let inp = this.ship_different.querySelector('#ship-to-different-address-checkbox')
                if (inp.checked) {
                    this.ship_different.querySelector('label').classList.add('checked')
                } else {
                    this.ship_different.querySelector('label').classList.remove('checked')
                }
            })

        }

        this.billing_country.addEventListener('change', () => {
            this.updateCheckout()
            // document.dispatchEvent(new Event("update_checkout"))
            // document.querySelector('body').dispatchEvent(new Event("update_checkout"))
        })


        jQuery('body').on('updated_checkout', (ev) => {
            console.log('update')
            this.checkIfPaymentMethodIsSelected()
            this.checkoutPrivacy()
            this.closeErrorPanel()
            this.activateRemove()
        })
        jQuery('body').on('payment_method_selected', (ev) => {
            this.checkIfPaymentMethodIsSelected()
            this.checkoutPrivacy()
            this.closeErrorPanel()
            this.activateRemove()
        })
        jQuery('body').on('checkout_error', (event, error) => {
            // console.log(error)
            clearInterval(this.interval)
            this.errorPanelProgress.value = 0            
            this.errorPanelError.innerHTML = error
            gsap.to(this.errorPanel, { duration: 0.5, x: 0, autoAlpha: 1, ease: 'power2.out' })
            this.interval = setInterval( () => {
                if(this.errorPanelProgress.value < 100){
                    this.errorPanelProgress.value++
                    gsap.set(this.errorPanelErrorProgressBar,{
                        width: this.errorPanelProgress.value+'%'
                    })
                }
                else{
                    this.closeErrorPanel()
                    clearInterval(this.interval)
                    this.errorPanelProgress.value = 0
                }
            },80)
        })
    }
    updateCheckout(){
        document.dispatchEvent(new Event("update_checkout"))
        document.querySelector('body').dispatchEvent(new Event("update_checkout"))
    }
    activateRemove(){
        if (document.querySelector('.remove-product-btn') !== null) {
            let removeProductButtons = [...document.querySelectorAll('.remove-product-btn')]
            let isCheckoutPage = true
            removeProductButtons.forEach(removeBtn => {
                removeBtn.addEventListener('click', () => {
                    let key = removeBtn.getAttribute('data-key')
                    removeFromCart(key, isCheckoutPage).then( () => {
                        let totalCount = parseInt(minicart.minicart.getAttribute('data-total-item'))
                        if(totalCount !== 0){
                            this.updateCheckout()
                            // document.dispatchEvent(new Event("update_checkout"))
                            // document.querySelector('body').dispatchEvent(new Event("update_checkout"))    
                        }
                        else{
                            location.reload()
                        }                    
                    })
                })
            })
        }
    }

    closeErrorPanel() {
        gsap.to(this.errorPanel, { 
            duration: 0.5, 
            x: '100%', 
            autoAlpha: 0, 
            ease: 'power2.out',
            onComplete: () => {
                gsap.set(this.errorPanelErrorProgressBar,{
                    width: '0%'
                })
            }
        })
    }

    //Con Locomotive rendo fixed il pannello degli errori
    // fixedErrorPanel() {
    //     awdScroll.on('scroll', args => {
    //         gsap.to(this.errorPanel, {
    //             duration: 0,
    //             y: args.scroll.y
    //         })
    //     })
    // }

    applyCoupon() {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'apply_coupon')
        formData.append('code', this.inputCoupon.inputField.value)
        // let url = document.getElementById('uri').value + '/AJAX/cart.php'
        let url = homeUrl + '/opzione-sito/ajax-cart'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                console.log(res)
                //Coupon success
                if (res.response === true) {
                    let successMessage = this.inputCoupon.labelError.getAttribute('data-success-apply')
                    this.inputCoupon.setMessage(successMessage)
                    this.inputCoupon.showMessage(false)
                    this.inputCoupon.resetField()
                    setTimeout(() => {
                        this.inputCoupon.hideMessage().then(() => {
                            this.inputCoupon.resetMessage()
                            this.isUploading = false

                            //Aggiorna la pagina di checkout sfruttando l'AJAX di default di woocommerce
                            this.updateCheckout()
                            // document.dispatchEvent(new Event("update_checkout"))
                            // document.querySelector('body').dispatchEvent(new Event("update_checkout"))
                        })
                    }, 2000)

                }
                else if (res.response === 'already-applied') {
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-already-applied')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'minimo-due-prodotti') {
                    // console.log('qui, minimo 2')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-minimo-due-prodotti')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'non-cumulabile') {
                    // console.log('non cumulabile')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-non-cumulabile')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                //Altri motivi (uso singolo, scaduto, non applicabile sui saldi, etc)
                else {
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-generic')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }

            }
        }
    }

    checkoutPrivacy() {
        let privacyCheckbox = document.getElementById('privacy_policy_field').querySelector('.privacy-checkbox-checkout')
        let check = document.getElementById('privacy_policy')
        check.addEventListener('change', (ev) => {
            if (ev.currentTarget.checked) {
                privacyCheckbox.classList.add('checked')
            } else {
                privacyCheckbox.classList.remove('checked')
            }
        })
    }
    checkIfPaymentMethodIsSelected() {
        let payment_methods = [...document.querySelectorAll('.wc_payment_methods .wc_payment_method')]
        payment_methods.forEach((el) => {
            let check = el.querySelector('.input-radio')
            if (check.checked) {
                el.classList.add('checked')
            } else {
                el.classList.remove('checked')
            }
        })
    }
    //Codice Fiscale obbligatorio solo in Italia - Attivare se il codice fiscale è attivato
    // checkCountryChange() {
    //     document.getElementById("billing_country").addEventListener("change", (event) => {
    //         if (event.target.value == "IT") {
    //             //console.log(event.target.value)
    //             document.getElementById('billing_fiscal_code').setAttribute('required', 'required')
    //             document.getElementById('billing_fiscal_code_field').classList.add('validate-required')
    //         } else {
    //             document.getElementById('billing_fiscal_code').setAttribute('required', '')
    //             document.getElementById('billing_fiscal_code_field').classList.remove('validate-required')
    //         }
    //     })
    // }
}


export {Checkout}